export const getLocalStorageItem = (key: string) => {
  return localStorage.getItem(key);
};

export const setLocalStorageItem = (key: string, value: any) => {
  return localStorage.setItem(key, value);
};
export const removeLocalStorageItem = (key: string) => {
  return localStorage.removeItem(key);
};
export const setLocalStorageAccessToken = (token: string) =>
  setLocalStorageItem("_token", token);

export const setLocalStorageRefreshToken = (token: string) =>
  setLocalStorageItem("refreshToken", token);

export const removeLocalStorageAccessToken = () =>
  localStorage.removeItem("_token");

export const removeLocalStorageRefreshToken = () =>
  localStorage.removeItem("refreshToken");

/** Parsed JSON from `_user` (profile from getProfile), or null if missing/invalid. */
export const getStoredUser = <T = Record<string, unknown>>(): T | null => {
  const raw = getLocalStorageItem("_user");
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
};

export const getLocalStorageAccessToken = () =>
  getLocalStorageItem("_token");

export const getLocalStorageRefreshToken = () =>
  getLocalStorageItem("refreshToken");
